// Modules
import styled from 'styled-components'

interface IconProps {
    transparent?: boolean
}

export const Container = styled.div`
    display: flex;
    flex: 2;
    flex-direction: column;
    background-color: #1f4fff;
    padding-bottom: 40px;
`

export const ContainerCarousel = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`

export const Border = styled.div`
    display: flex;
    background-color: #fff;
    border-radius: 0 0 1.5rem 1.5rem;
    height: 1.5rem;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 16px;
    padding: 16px;
    border: 1px solid #f2f2f2;
    border-radius: 24px;
    width: 330px;
    margin: 0 auto;
    position: relative;
`

export const TitleLaboratory = styled.text`
    color: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
`

export const AccessText = styled.div`
    position: absolute;
    top: -10px;
    left: 5%;
    background-color: #1f4fff;
    padding: 0 8px;
    color: #fefefe;
    text-align: center;
    font-family: 'Dasa Sans';
    font-weight: 700;
    font-size: 12px;
    display: flex;
    align-items: center;
`

export const VectorImg = styled.img`
    position: absolute;
    top: 1.5px;
    right: -15px;
    width: 16px;
    height: auto;
`

export const Button = styled.button`
    background-color: white;
    border-radius: 24px;
    width: 140px;
    height: 120px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: left;
    padding: 24px;
    span {
        color: #000e40;
        font-size: 14px;
        text-align: left;
        white-space: normal;
        word-wrap: break-word;
    }
`

export const Icon = styled.div<IconProps>`
    font-size: 24px;
    color: ${props => (props.transparent ? '#1616163D' : '#ff4e33')};
`
export const Chevron = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 34px;
    gap: 45px;
`
